import { css } from '@emotion/react';
import { EmptyStates } from '@frontend/components';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { SwitchToLargeModeButton } from './switch-to-large-mode-button';

interface LargeModeOnlyFeatureProps {
  featureName: string;
}

export const LargeModeOnlyFeature = ({ featureName }: LargeModeOnlyFeatureProps) => {
  const { t } = useTranslation('analytics');

  return (
    <div css={styles.wrapper}>
      <EmptyStates
        emptyStateConfig={{
          type: 'analytics',
          header: '',
        }}
      />
      <Text css={styles.message}>
        {t('The {{featureName}} is only available in Large Mode. Switch to access full insights.', { featureName })}
      </Text>
      <SwitchToLargeModeButton />
    </div>
  );
};

const styles = {
  wrapper: css`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: ${theme.spacing(4)};
  `,

  message: css`
    margin-bottom: ${theme.spacing(2)};
    margin-top: ${theme.spacing(-3)};
    max-width: 336px;
    text-align: center;
  `,
};
